// extracted by mini-css-extract-plugin
module.exports = {"language":"_3fea778","language_icon":"bb697c02","icon":"_1632844","mask":"fe36133c","list":"a28e19ff","language_list":"_1303601","triangle_up":"_4c8fa27","active":"e9e2c074"};